export const getLevelSelectOptions = () => {
  const selectLevelOptions = [
    { value: "1", label: "1" },
    { value: "1.1", label: "1.1" },
    { value: "1.2", label: "1.2" },
    { value: "2", label: "2" },
  ]
  return selectLevelOptions
}

export const getTypeControlSelectOptions = trad => {
  const selectControlOptions = [
    { value: "controle", label: trad?.CONTROL },
    { value: "mitigant", label: trad?.MITIGANT },
  ]
  return selectControlOptions
}

export const getSampleSelectOptions = trad => {
  const selectionSampleOptions = [
    { value: "echantillon", label: trad?.SAMPLE_SINGULAR },
    { value: "exhaustif", label: trad?.EXHAUSTIVE },
  ]
  return selectionSampleOptions
}

export const getTypeOfControlSelectOptions = trad => {
  const selectionSampleOptions = [
    { value: "dispositif", label: trad?.DISPOSITIF },
    { value: "testing", label: trad?.TESTTING },
  ]
  return selectionSampleOptions
}
